var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoJobs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 406.41,
    viewBox: "0 0 800 406.41",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-409.001 -366.07)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.354,
    cy: 6.508,
    rx: 266.354,
    ry: 6.508,
    transform: "translate(409 621.95)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(449.528 392.537)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(0 174.907)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(35.795 184.67)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(39.659 185.483)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(103.317 174.907)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(139.112 184.67)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(142.977 185.483)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(0 117.147)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(35.795 126.91)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(39.659 127.723)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(103.317 117.147)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(139.112 126.91)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(142.977 127.723)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(0 58.574)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(35.795 68.336)",
    fill: "#090814",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(39.659 69.149)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(103.317 58.574)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(139.112 68.336)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(142.977 69.149)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(103.317 0)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(139.112 9.762)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(142.977 10.576)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(656.163 391.723)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(0 174.907)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(35.795 184.67)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(39.659 185.483)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(103.317 174.907)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(139.112 184.67)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(142.977 185.483)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(0 117.147)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(35.795 126.91)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(39.659 127.723)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(103.317 117.147)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(139.112 126.91)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(142.977 127.723)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(0 58.574)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(35.795 68.336)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(39.659 69.149)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(103.317 58.574)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(139.112 68.336)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(142.977 69.149)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(103.317)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(139.112 9.762)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(142.977 10.576)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M738.673,465.643a3.7,3.7,0,0,0-2.026-2.912,3.783,3.783,0,0,0-5.011,2.115l-18.068,38.016L709.5,652.55h6.508l2.44-149.355L738.331,468A3.863,3.863,0,0,0,738.673,465.643Z",
    transform: "translate(178.924 55.228)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.479,733.392a117.775,117.775,0,0,1-17.149,12.455,2.845,2.845,0,0,1-.317.374,5.3,5.3,0,0,1-2.237,1.123h0a133.916,133.916,0,0,1-65.961,16.938H429.524C378.272,759.01,347,752.021,347,744.35c0-5.947,18.776-11.487,51.106-16.124q5.028-.732,10.486-1.416,3.36-.423,6.874-.813l3.978-.464q4.426-.5,9.087-.984h.252l3.254-.325q4.124-.427,8.42-.814l2.083-.187,5.312-.472q5.174-.463,10.576-.887,4.483-.35,9.112-.7c31.288-2.318,67.36-4.068,106.612-5.2l11.21-.382,3.775-.081,7.973-.179,3.2-.065,3.36-.065,2.392-.041,11.227-.179,5.768-.081h1.18q20.46-.244,41.685-.252c27.969,0,55.092.333,80.937.968h0q22.258.537,43.157,1.367h.13c40.172,1.578,76.129,3.9,105.888,6.793l.545.057c7.639.74,14.871,1.53,21.656,2.343,6.386.765,12.382,1.57,17.946,2.392,1.928.285,3.8.578,5.622.862l.464.081C949.975,730.748,956.744,732.017,962.479,733.392Z",
    transform: "translate(246.522 8.196)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.736,354.957c4.979-1.342,9.413-4.149,13.757-6.923l15.14-9.64c-4.108-.325-7.655-3.254-9.762-6.8s-2.977-7.672-3.693-11.723c-6.508,2.538-12.146,6.842-17.4,11.389-2.083,1.8-6.508,4.515-7.151,7.322s3.457,5.084,5.044,6.964C865.213,346.171,870.347,354.51,868.736,354.957Z",
    transform: "translate(150.941 81.812)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.6,459.99c-2.668,1.367-5.508,2.766-8.493,2.571a12.34,12.34,0,0,1-7.151-3.409c-1.627-1.415-3.3-3.181-5.442-3.034a6.973,6.973,0,0,0-3.742,1.985l-5.9,4.938a5.548,5.548,0,0,0-2.14,2.766,5.481,5.481,0,0,0,.138,2.294c.269,1.318.716,2.855,1.985,3.3s2.652-.513,3.994-.879a4.7,4.7,0,0,1,4.613,1.359,2.742,2.742,0,0,1,.813,1.773c0,1.473-1.627,2.441-3.124,2.514s-2.929-.415-4.409-.325a.675.675,0,0,0-.757.6,3.108,3.108,0,0,0,.952,2.831,8.258,8.258,0,0,0,2.652,1.627,10.821,10.821,0,0,0,3.628,1.058c2.5.163,4.792-1.22,7.159-2.026,3.189-1.074,6.622-1.106,9.99-1.1s6.785.057,10.015-.887,6.3-3.034,7.558-6.15a1.481,1.481,0,0,0,.138-.944,1.561,1.561,0,0,0-.683-.813c-4.54-3.36-6.378-7.444-11.487-9.86Z",
    transform: "translate(175.348 56.406)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.233,353.871a9.811,9.811,0,0,0-8.607-1,18.581,18.581,0,0,0-7.411,4.938,34.088,34.088,0,0,0-5.231,6.907c-1.383,2.441-2.441,4.995-3.824,7.427a79,79,0,0,1-8.835,12,34.066,34.066,0,0,1-6.565,6.508c-2.555,1.741-5.41,2.807-7.143,5.223-.545.765-.936,1.627-1.472,2.4-1.7,2.489-4.588,3.824-7.1,5.491-7.208,4.8-11.69,12.789-18.426,18.231-2.9,2.343-6.183,4.182-9.038,6.573-2.66,2.221-4.881,4.881-7.533,7.159s-5.768,4.157-9.225,4.369c2.31,5.15,5.068,10.2,9.03,14.212s9.9,6.573,15.31,5a6.652,6.652,0,0,0,4.531-3.58,15.3,15.3,0,0,1,.96-2.774,5.7,5.7,0,0,1,2.058-1.684,486.328,486.328,0,0,0,61.917-42.9c5.231-4.263,10.421-8.078,15.79-12.2a34.513,34.513,0,0,0,5.312-4.653,17.686,17.686,0,0,0,2.148-19.484,46.208,46.208,0,0,0-4.93-6.679A58.7,58.7,0,0,0,863.233,353.871Z",
    transform: "translate(168.981 75.764)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.233,353.871a9.811,9.811,0,0,0-8.607-1,18.581,18.581,0,0,0-7.411,4.938,34.088,34.088,0,0,0-5.231,6.907c-1.383,2.441-2.441,4.995-3.824,7.427a79,79,0,0,1-8.835,12,34.066,34.066,0,0,1-6.565,6.508c-2.555,1.741-5.41,2.807-7.143,5.223-.545.765-.936,1.627-1.472,2.4-1.7,2.489-4.588,3.824-7.1,5.491-7.208,4.8-11.69,12.789-18.426,18.231-2.9,2.343-6.183,4.182-9.038,6.573-2.66,2.221-4.881,4.881-7.533,7.159s-5.768,4.157-9.225,4.369c2.31,5.15,5.068,10.2,9.03,14.212s9.9,6.573,15.31,5a6.652,6.652,0,0,0,4.531-3.58,15.3,15.3,0,0,1,.96-2.774,5.7,5.7,0,0,1,2.058-1.684,486.328,486.328,0,0,0,61.917-42.9c5.231-4.263,10.421-8.078,15.79-12.2a34.513,34.513,0,0,0,5.312-4.653,17.686,17.686,0,0,0,2.148-19.484,46.208,46.208,0,0,0-4.93-6.679A58.7,58.7,0,0,0,863.233,353.871Z",
    transform: "translate(168.981 75.764)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.992,724c-1.424.814-3.173,1.269-4.173,2.587-.325.423-.545.919-.895,1.326-1.082,1.269-3,1.326-4.507,2.05-1.2.569-2.18,1.627-3.457,1.961a7.505,7.505,0,0,1-2.335.179l-7.907-.236c-2.506-.073-5.442.057-6.9,2.1a7.451,7.451,0,0,0-.992,2.441c-.61,2.335-1.106,4.979.171,7.029,1.529,2.441,4.881,2.937,7.769,3.1a224.256,224.256,0,0,0,33.468-.651,26.463,26.463,0,0,1,4.539-.187c1.2.1,2.384.366,3.571.57,6,1.017,12.13.423,18.182-.179a9.506,9.506,0,0,0,2.986-.635,3.164,3.164,0,0,0,1.9-2.253c.252-1.676-1.318-3.1-1.489-4.784-.122-1.188.447-2.514-.2-3.523a5.809,5.809,0,0,0-.813-.814,8.008,8.008,0,0,1-1.676-4.328L871.8,721.4a2.57,2.57,0,0,0-.683-1.578,2.348,2.348,0,0,0-1.009-.415c-6.2-1.4-12.553-.122-18.711.659a50.284,50.284,0,0,1-9.575.48c-1.383-.089-1.92-.252-2.953.651S837.286,723.247,835.992,724Z",
    transform: "translate(161.264 7.424)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.42,735.377a13.717,13.717,0,0,1-3.465,1.359q-4.792,1.4-9.567,2.921a6.343,6.343,0,0,0-2.335,1.123,5.678,5.678,0,0,0-1.473,4.068,5.1,5.1,0,0,0,.285,2.441,4.878,4.878,0,0,0,1.627,1.806c3.644,2.758,8.4,3.612,12.976,3.612s9.111-.773,13.683-.895c5.524-.146,11.194.635,16.506-.911a14.05,14.05,0,0,1,3.14-.765,13.318,13.318,0,0,1,2.131.138,22.6,22.6,0,0,0,8.477-.773,5.218,5.218,0,0,0,2.245-1.115,2.1,2.1,0,0,0,.6-2.294c-.293-.659-1.041-1.139-1.049-1.863a3.5,3.5,0,0,1,.269-1.009c.333-1.115-.2-2.278-.578-3.376-1.049-3.14-.878-6.752-2.758-9.478s-5.328-3.848-8.607-4.279a23.868,23.868,0,0,0-8.013.228c-2.969.635-5.743,1.961-8.656,2.807a28.313,28.313,0,0,1-10.413.984c-2.327-.2-1.529.171-2.318,2.123A6.924,6.924,0,0,1,1023.42,735.377Z",
    transform: "translate(123.533 6.105)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.592,
    cy: 23.592,
    r: 23.592,
    transform: "translate(993.368 378.3)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.077,652.782c-7.322,6.288-17.206,9.038-26.846,9.136-4.068.041-8.29-.4-11.755-2.506-.244-1.334-.342-2.774-.586-4.108-4.206-.879-7.468-4.3-9.5-8.094s-3.067-8.005-4.58-12.024c-2.31-6.118-5.695-11.755-9.079-17.352-3.108-5.158-6.224-10.332-9.762-15.2-2.343-3.254-4.881-6.313-7.2-9.559a84.611,84.611,0,0,1-13.87-30.149,39.421,39.421,0,0,0-1.684-6.126c-1.4-3.4-3.962-6.167-5.939-9.266a30.615,30.615,0,0,1-4.3-10.974c-.4-2.213-1.082-4.6-3.3-4.832h0c-4.67,9.071-9.429,18.288-16.49,25.667a26.612,26.612,0,0,0-3.034,3.466,33.326,33.326,0,0,0-1.953,3.742,24.108,24.108,0,0,1-4.312,6.28,10.055,10.055,0,0,1-5.548,3.026,37.942,37.942,0,0,1-2.668,23.185c-.984,2.148-2.164,4.2-3.091,6.37-3.791,8.949-2.912,19.044-3.311,28.75a30.227,30.227,0,0,1-.716,6.044c-.984,3.97-3.018,8.192-2.034,12.162-10.2,3.9-21.534,3.653-32.338,2.009a15.581,15.581,0,0,1-6.028-1.83,16.585,16.585,0,0,1-3.954-3.954,3.962,3.962,0,0,1-.9-1.57c-.423-1.855,1.627-3.254,2.579-4.881s1.123-4.206-.187-5.54c.651-10.649,3.6-21.046,4.247-31.727.26-4.23.155-8.477.35-12.715s.651-8.363,1.123-12.528c1.074-9.51,3.677-18.833,3.311-28.392a16.514,16.514,0,0,1,1.961-8.452,42.625,42.625,0,0,1,3.986-5.6c5-6.451,11-12.919,12.78-20.883.919-4.108,2.953-7.867,4.971-11.56a20.468,20.468,0,0,1,4.344-6.077,19.039,19.039,0,0,0,2.872-2.441c1.334-1.716,1.383-4.068,2.172-6.118.407-1.058,1.033-2.034,1.334-3.124a17.807,17.807,0,0,0,.366-3.661c.26-3.937,1.774-7.745,3.368-11.349a34.762,34.762,0,0,1-9.762-8.412,20.585,20.585,0,0,1-2.359-3.555c-1.676-3.3-2.058-7.069-2.847-10.69-1.879-8.64-6.2-16.767-6.8-25.593-.179-2.693,0-5.475-.936-8.021a25.236,25.236,0,0,0-1.513-3.132,12.808,12.808,0,0,1-1.285-3.156c-.521-2.4.2-4.881,0-7.322-.2-2.156-1.115-4.173-1.57-6.28a29.818,29.818,0,0,1-.236-8.3c.2-3.254.911-6.614.635-9.827A37.967,37.967,0,0,1,871.4,346.5l.187-.187c1.554-1.627,3.254-3.067,4.653-4.792,1.9-2.31,3.254-5.028,5.263-7.273.879-1,1.871-1.9,2.742-2.9a24.119,24.119,0,0,1,2.644-2.961c.987-.917,4.221,1.4,4.8,2.481,1.692.13,3.2.366,4.881.5a11.025,11.025,0,0,1,2.31.358,15.033,15.033,0,0,1,4.214,2.611c3.384,2.384,7.541,3.49,10.869,5.947,4.881,3.62,7.322,9.6,10.267,14.961,3.9,7.183,10.25,13.293,13.016,20.973l3.815,10.446a163.16,163.16,0,0,0,8.379,20.086c4.71,8.949,11.088,17.011,14.871,26.374a4.247,4.247,0,0,0,1.977,2.18,170.133,170.133,0,0,1,13.692,22.779c2.091,4.2,4.067,8.558,4.669,13.2.887,6.565-.9,13.2-3.392,19.337a10.078,10.078,0,0,0-.813,2.766c-.163,1.554.431,3.083.594,4.637a8.584,8.584,0,0,1-.627,4.263,19.53,19.53,0,0,0-1.277,2.945c-.439,1.871.342,3.775.765,5.646,1.432,6.337,1.171,12.9.813,19.394-.187,3.254,2.441,5.833,4.629,8.217,4.068,4.466,7.24,9.689,10.307,14.9a48.167,48.167,0,0,1,4.2,8.363,69.332,69.332,0,0,1,2.27,10.307c2.067,10.665,8.835,20.094,10.673,30.792a27.361,27.361,0,0,0,6.281,13.236,28.829,28.829,0,0,1,2.709,3.254,13.1,13.1,0,0,1,1.334,2.912,21.437,21.437,0,0,1,1.115,7.379,11.023,11.023,0,0,0,.2,3.588c.765,2.481,3.5,3.848,4.621,6.183s.35,5.329.814,7.981a8.591,8.591,0,0,0,3.213,5.4Z",
    transform: "translate(154.918 80.264)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.6,450.99c-2.668,1.367-5.508,2.766-8.493,2.571a12.34,12.34,0,0,1-7.151-3.409c-1.627-1.416-3.3-3.181-5.443-3.034a6.972,6.972,0,0,0-3.742,1.985l-5.9,4.938a5.548,5.548,0,0,0-2.14,2.766,5.482,5.482,0,0,0,.138,2.294c.268,1.318.716,2.855,1.985,3.3s2.652-.513,3.994-.879a4.7,4.7,0,0,1,4.613,1.359,2.742,2.742,0,0,1,.814,1.773c0,1.473-1.627,2.441-3.124,2.514s-2.929-.415-4.409-.325a.675.675,0,0,0-.757.6,3.108,3.108,0,0,0,.952,2.831,8.256,8.256,0,0,0,2.652,1.627,10.821,10.821,0,0,0,3.628,1.058c2.5.163,4.792-1.22,7.159-2.026,3.189-1.074,6.622-1.106,9.99-1.1s6.785.057,10.014-.887,6.3-3.034,7.558-6.15a1.48,1.48,0,0,0,.138-.944,1.562,1.562,0,0,0-.683-.813c-4.54-3.36-6.378-7.444-11.487-9.86Z",
    transform: "translate(174.229 58.084)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.233,344.871a9.812,9.812,0,0,0-8.607-1,18.58,18.58,0,0,0-7.411,4.938,34.091,34.091,0,0,0-5.231,6.907c-1.383,2.44-2.441,4.995-3.824,7.427a79,79,0,0,1-8.835,12,34.064,34.064,0,0,1-6.565,6.508c-2.554,1.741-5.41,2.807-7.143,5.223-.545.765-.935,1.627-1.472,2.4-1.7,2.489-4.588,3.824-7.1,5.491-7.208,4.8-11.69,12.789-18.426,18.231-2.9,2.343-6.183,4.182-9.038,6.573-2.66,2.221-4.881,4.881-7.533,7.159s-5.768,4.157-9.225,4.369c2.31,5.15,5.068,10.2,9.03,14.212s9.9,6.573,15.31,5a6.652,6.652,0,0,0,4.531-3.579,15.317,15.317,0,0,1,.96-2.774,5.694,5.694,0,0,1,2.058-1.684,486.327,486.327,0,0,0,61.917-42.9c5.231-4.263,10.421-8.078,15.791-12.2a34.518,34.518,0,0,0,5.312-4.653,17.686,17.686,0,0,0,2.148-19.484,46.215,46.215,0,0,0-4.93-6.679,58.7,58.7,0,0,0-11.715-11.487Z",
    transform: "translate(167.862 77.442)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.406,
    cy: 24.406,
    r: 24.406,
    transform: "translate(818.054 710.624)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.406,
    cy: 24.406,
    r: 24.406,
    transform: "translate(818.054 710.624)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.457,
    cy: 15.457,
    r: 15.457,
    transform: "translate(827.003 719.573)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.457,
    cy: 15.457,
    r: 15.457,
    transform: "translate(827.003 719.573)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630,682.071l16.01,36.2a3.108,3.108,0,0,0,5.638.114l19.028-38.756Z",
    transform: "translate(193.748 14.725)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630,682.071l16.01,36.2a3.108,3.108,0,0,0,5.638.114l19.028-38.756Z",
    transform: "translate(193.748 14.725)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.406,
    cy: 24.406,
    r: 24.406,
    transform: "translate(665.925 710.624)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.406,
    cy: 24.406,
    r: 24.406,
    transform: "translate(665.925 710.624)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.457,
    cy: 15.457,
    r: 15.457,
    transform: "translate(674.874 719.573)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.457,
    cy: 15.457,
    r: 15.457,
    transform: "translate(674.874 719.573)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,682.071l16.01,36.2a3.108,3.108,0,0,0,5.638.114l19.028-38.756Z",
    transform: "translate(228.62 14.725)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,682.071l16.01,36.2a3.108,3.108,0,0,0,5.638.114l19.028-38.756Z",
    transform: "translate(228.62 14.725)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.605,467.643a3.7,3.7,0,0,0-2.026-2.912,3.783,3.783,0,0,0-5.011,2.115l-14,34.762L719.5,657.8h6.508l2.441-155.863L744.264,470a3.863,3.863,0,0,0,.342-2.359Z",
    transform: "translate(177.059 54.855)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.5,559.124l21.965-13.83,237.142-2.034,6.1,15.864Z",
    transform: "translate(265.291 141.332)",
    fill: "#273679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.5,576.807V562.163l269.5-2.6-.26,9.925H373.381v7.322Z",
    transform: "translate(265.291 138.292)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.406,
    cy: 24.406,
    r: 24.406,
    transform: "translate(643.553 719.166)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.457,
    cy: 15.457,
    r: 15.457,
    transform: "translate(652.502 728.115)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.5,692.57l16.01,36.2a3.108,3.108,0,0,0,5.638.114l19.028-38.756Z",
    transform: "translate(233.748 12.767)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.406,
    cy: 24.406,
    r: 24.406,
    transform: "translate(833.104 719.166)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.457,
    cy: 15.457,
    r: 15.457,
    transform: "translate(842.053 728.115)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.5,692.57l16.01,36.2a3.108,3.108,0,0,0,5.638.114l19.028-38.756Z",
    transform: "translate(190.299 12.767)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(664.298 636.594)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(700.093 646.356)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(703.957 647.169)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(767.615 636.594)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(803.41 646.356)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(807.275 647.169)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(664.298 578.833)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(700.093 588.596)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(703.957 589.409)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(767.615 578.833)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(803.41 588.596)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(807.275 589.409)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(664.298 520.26)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(700.093 530.022)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(703.957 530.836)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(767.615 520.26)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(803.41 530.022)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(807.275 530.836)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101.69,
    height: 56.133,
    transform: "translate(767.615 461.686)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.914,
    height: 6.508,
    transform: "translate(803.41 471.448)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.185,
    height: 4.881,
    transform: "translate(807.275 472.262)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.308,127.67c12.766-5.4,11.291,13.986,11.291,13.986l2.432,4.62,10.734-20.4c6.456-19.788-16.116-31.157-16.116-31.157-7.355-8.663-22.161,1.475-22.161,1.475-21.341-4.737-11.037,13.254-11.037,13.254s7.276.166,7.276,6.056,7.931,5.479,7.931,5.479l6.212,10.88,3.438-4.171v-.02Z",
    transform: "translate(471.405 274.855)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoJobs);
export default __webpack_public_path__ + "static/media/no-jobs.ed65d515407900d13b3c66e023506347.svg";
export { ForwardRef as ReactComponent };